import React from "react";

import VideosSection from "../../components/VideoSection/VideoSection";
import { productManagersVideos } from "../../helpers/videos";

export default function HowToManagers() {
  return <VideosSection videos={productManagersVideos} />;
}
